import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { Language } from '../../shared/components/ILanguage';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { Member } from '../../shared/interface/member.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { Constants, IsoCodeThree, UserTitleType } from '../common/constants';
import { MemberLevel } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { IdentificationTypeConstant } from '../constants/identification-type.constant';
import { BusinessInfoType } from '../enums/business-info-type.enum';
import { ContactPreferenceType } from '../enums/contact-preference-type.enum';
import { MemeberCommunicationPreferenceValue } from '../enums/member-communication-preference-value.enum';
import { MemberMetaDataEnum } from '../enums/member-meta-data.enum';
import { MemberPreferenceType } from '../enums/member-preference-type.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { AddressType } from '../enums/order-source-type';
import { TaxProvider } from '../enums/tax-provider-type.enum';
import { Address } from '../interface/address';
import { BonusInfo } from '../interface/bonus-info.interface';
import { BusinessInfo } from '../interface/business-info.interface';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import {
    EnrollInfo, EnrollSession,
    LegalRequirements, MemberIdentification, PersonalInfo, PersonalInformation, SponsorInformation, TransliteratedInfo, VerifyAccountResponse
} from '../interface/enrollment';
import { DocumentLibrary } from '../interface/enrollment/document-library.interface';
import { MemberPreference } from '../interface/enrollment/member-preference.interface';
import { IdentificationType } from '../interface/identification-types.interface';
import { MemberContact } from '../interface/member-contact';
import { MemberMetaDataRequest } from '../interface/member-meta-data-request.interface';
import { PersonalInfoConfig } from '../interface/personal-info-config.interface';
import { TaxType } from '../interface/tax-type.interface';
import { AppConfigService } from './app-config.service';
import { CheckoutConfigService } from './checkout-config.service';
import { CustomerService } from './customer.service';
import { PersonalInfoConfigService } from './personal-info-config.service';

/**
 * @description this service used to
 * get account information and create user info
 * @date 2018-07-31
 * @export
 * @class EnrollService
 */
@Injectable()
export class EnrollService {
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    privacyPreference: boolean = true;
    contactPreferenceModels: any[];


    constructor(
        private _http: Http,
        private _datePipe: DatePipe,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _cacheService: CacheService,
        private _checkoutConfigService: CheckoutConfigService,
        private _commonService: CommonService,
        private _customerService: CustomerService

    ) { }

    /**
     * to validate new email
     * @param  {any} emailId
     * @returns Observable
     */
    verifyEmailAccountExists(emailId: string): Observable<any> {
        const encodedEmail = encodeURIComponent(emailId);
        let url = ApiUrlConstants.accountApiUrl + 'member-information?email=' + encodedEmail;
        if (environment.enableLongPoll) {
            url = url + '&isPoll=' + environment.enableLongPoll;
        }
        return this._http
            .get(url)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description to validate new GovernmentId
     * @date 2019-02-22
     * @param {string} governmentId
     * @param {string} countryCode
     * @param {number} storeId
     * @param {number} [memberId]
     * @returns {Observable<any>}
     * @memberof EnrollService
     */
    validateGovernmentId(governmentId: string, countryCode: string, storeId: number, memberId?: number)
        : Observable<any> {
        let _restUrl = ApiUrlConstants.accountApiUrl + 'members/check-unique-identification/?storeId=' + storeId
            + '&governmentId=' + governmentId + '&countryCode=' + countryCode;
        if (memberId) {
            _restUrl = _restUrl + '&memberId=' + memberId;
        }
        return this._http
            .get(_restUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * This method used for verify phone number account exists or not
     * verifyPhoneNumberAccountExists
     * @param {string} phoneNumber
     * @returns {Observable<any>}
     * @memberof EnrollService
     */
    verifyPhoneNumberAccountExists(phoneNumber: string): Observable<any> {
        return this._http
            .get(ApiUrlConstants.accountApiUrl + 'member-exists?phone=' + phoneNumber)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this method will use to enroll
     * memebr into system
     * @date 2018-07-31
     * @param {*} enrollRequest
     * @returns {Observable<any>}
     * @memberof EnrollService
     */
    createEnrollRequest(enrollRequest: EnrollInfo,tansliteratedObj:TransliteratedInfo): Observable<EnrollInfo> {
        let url = ApiUrlConstants.enrollmentApigwUrl + 'enrollment?enableTransliterate=' + tansliteratedObj.enableTransliterate + '&languageCode=' + tansliteratedObj.languageCode;
        return this._http
            .post(decodeURIComponent(encodeURIComponent(url)),
                decodeURIComponent(encodeURIComponent(JSON.stringify(enrollRequest))))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this method will use to update
     * memebr into system
     * @date 2018-07-31
     * @param {*} enrollRequest
     * @param {number} memberId
     * @returns {Observable<any>}
     * @memberof EnrollService
     */
    updateEnrollment(enrollRequest: EnrollInfo, memberId: number, transliterateObj:TransliteratedInfo): Observable<EnrollInfo> {
        let url = ApiUrlConstants.enrollmentApigwUrl + 'enrollment/members/' + memberId + '?enableTransliterate=' + transliterateObj.enableTransliterate + '&languageCode=' + transliterateObj.languageCode;
        return this._http
            .put(url, JSON.stringify(enrollRequest))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this method will update enrol user
     * session
     * @date 2018-07-31
     * @param {string} sessionGuid
     * @param {EnrollSession} sessionRequest
     * @returns {Observable<any[]>}
     * @memberof EnrollService
     */
    updateEnrollSession(sessionGuid: string, sessionRequest: EnrollSession): Observable<EnrollSession> {
        return this._http
            .put(ApiUrlConstants.orderApiUrl + '/V1/enrollsession/' + sessionGuid, sessionRequest)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this method is used
     * to map the validated account response to user info  varible of
     * personalinfo settings
     * @date 2018-07-19
     * @private
     * @memberof PersonalInfoComponent
     */
    mapAccountResponseToUserInfo(verifyAccountResponse: VerifyAccountResponse): Member {
        const userInfo: Member = {
            distributorId: verifyAccountResponse.distributorId,
            email: verifyAccountResponse.email,
            firstName: verifyAccountResponse.firstName,
            fullName: verifyAccountResponse.fullName,
            homeCountryId: verifyAccountResponse.homeCountryId,
            lastName: verifyAccountResponse.lastName,
            memberAllowedCountries: verifyAccountResponse.memberAllowedCountries,
            memberPreferences: verifyAccountResponse.memberPreferences, 
            memberId: verifyAccountResponse.memberId,
            memberTitle: verifyAccountResponse.memberTitle,
            memberTitleId: verifyAccountResponse.memberTitleId,
            memberType: verifyAccountResponse.memberType,
            memberTypeId: verifyAccountResponse.memberTypeId,
            middleName: verifyAccountResponse.middleName,
            phone: verifyAccountResponse.phone,
            profileImageURL: verifyAccountResponse.profileImageURL,
            sponsorId: verifyAccountResponse.sponsorId,
            userEntityId: verifyAccountResponse.userEntityId,
            userId: verifyAccountResponse.userId,
            userName: verifyAccountResponse.userName,
            userType: verifyAccountResponse.userType,
            wholeSaleQualified: false,
            preferenceValue: verifyAccountResponse.preferenceValue,
            displayName: verifyAccountResponse.displayName,
            optIn: false,
            isExternal: verifyAccountResponse.external

        };
        return userInfo;
    }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response) {
        return Observable.throw(error);
    }

    /**
    * processPollRequest
    * @param  {Order} processPollRequest
    * @returns Observable
    */
    processPollRequest(requestUrl: string): Observable<any> {
        return (
            this._http
                .get(decodeURIComponent(encodeURIComponent(requestUrl)))
                .map((res: Response) => res.json())
                .catch(this.handleErrorObservable)
        );
    }

    /**
     * @description this method will save
     * user enroll session
     * @date 2018-07-31
     * @param {EnrollSession} sessionRequest
     * @returns {Observable<any>}
     * @memberof EnrollService
     */
    saveEnrollSession(sessionRequest: EnrollSession): Observable<EnrollSession> {
        return this._http
            .post(ApiUrlConstants.orderApiUrl + '/V1/enrollsession', sessionRequest)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description to prepare  fpc opting personalInfo
     * @date 2019-09-12
     * @returns {PersonalInfo}
     * @memberof EnrollService
     */
    getOptInPersonalInfo(userInfo: Member, legalRequirements?: LegalRequirements, memberContact?: MemberContact []): PersonalInformation {
        const phoneType = memberContact ? memberContact.find(x => x.contactTypeID === ContactTypeValue.MOBILE) : null;
        const personalInformation: PersonalInformation = {
            firstName: userInfo.firstName,
            middleName: userInfo.middleName ? userInfo.middleName : '',
            lastName: userInfo.lastName,
            email: userInfo.email,
            sponserId: userInfo.sponsorId,
            phoneNumber: phoneType ? phoneType.value :  userInfo.phone,
            pass_word: '',
            confirmPassword: '',
            address: null,
            dateOfBirth: legalRequirements.dateOfBirth,
            governmentId: legalRequirements.governmentId,
            phoneType: phoneType ? phoneType.contactTypeID : ContactTypeValue.MOBILE
        };
        return personalInformation;
    }

    /**
     * @description to prepare personalInfo
     * @date 2019-09-12
     * @returns {PersonalInfo}
     * @memberof EnrollService
     */
    preparePersonalInfo(storeInfo: StoreConfig, languageCode: string, personalInformation: PersonalInformation,
         shippingAddressInfo, countryCode: string, countryId: number, sponsorInformation: SponsorInformation,
          agreementDocuments: DocumentLibrary[], memberInfo: Member, memberTypeId: MemberTypeEnum,
           legalRequirements: LegalRequirements, mailingAddress?: Address, memberMailingAddress?: Address,
           govtIdentificationTypes?: IdentificationType[], bonusInformation?: BonusInfo, isEnrollmentFlow?: boolean, bonusInfoAgreements?: DocumentLibrary[],businessInformation?: BusinessInfo): PersonalInfo {
        const language: Language = storeInfo.languages.find(x => x.cultureName.toLowerCase()
            === languageCode.toLowerCase());
        if (personalInformation) {
                personalInformation.address = JSON.parse(JSON.stringify(memberMailingAddress ? memberMailingAddress: mailingAddress ?
                mailingAddress : shippingAddressInfo));
            if(memberTypeId === MemberTypeEnum.DISTRIBUTOR){
                personalInformation.middleName = personalInformation.middleName ? personalInformation.middleName : '';
            }
            if (personalInformation.address) {
                personalInformation.address.addressType = AddressType.MAILING;
                personalInformation.address.phone = personalInformation.address.phone ?
                personalInformation.address.phone.replace(/[^a-zA-Z0-9]/g, '') : '';
                personalInformation.address.email = personalInformation.email ? personalInformation.email : null;
            }
            if(memberTypeId === MemberTypeEnum.DISTRIBUTOR){
                personalInformation.phoneNumber = personalInformation.phone ?
            personalInformation.phone.replace(/[^a-zA-Z0-9]/g, '') : '';
            }
            else{
                personalInformation.phoneNumber = personalInformation.phoneNumber ?
            personalInformation.phoneNumber.replace(/[^a-zA-Z0-9]/g, '')  : '';
            }
            const personalInfo: PersonalInfo = Object.assign({} as any, personalInformation);
            personalInfo.storeId = storeInfo.id;
             personalInfo.memberContacts = this.getMemberContacts(personalInformation);
           // personalInfo.memberContacts = memberInfo.memberContacts;
            personalInfo.memberType = this.getMemberTitle(memberTypeId, isEnrollmentFlow);
            personalInfo.memberTypeId = memberTypeId;
            personalInfo.countryCode = countryCode;
            personalInfo.homeCountryCode = storeInfo.homeIsocodeThree;
            personalInfo.countryId = countryId;
            personalInfo.memberMetadataModels = sponsorInformation ? sponsorInformation.memberMetadataModels : null;
            personalInfo.languagePreference = language ? language.languageId + '' : '';
            personalInfo.memberPreferences = language ?
             this.getMemberPreferences(language, sponsorInformation, memberTypeId,storeInfo) : null;
            personalInfo.sponsorId = sponsorInformation ? sponsorInformation.sponsorId : memberInfo ? memberInfo.sponsorId : '';
            if(bonusInfoAgreements && bonusInfoAgreements.length > 0) {
                bonusInfoAgreements.forEach(agree => {
                    agreementDocuments.push(agree);
                });
            }
            personalInfo.documents = this.getAcceptedDocuments(agreementDocuments, countryId, memberTypeId);
            personalInfo.currentMemberType = this.getCurrentMemberType(memberTypeId);
            const personalInfoConfig = this._personalInfoConfigService.getSettings(storeInfo.homeIsocodeThree);
            if ((memberTypeId === MemberTypeEnum.FPC) && legalRequirements) {
                personalInfo.dateOfBirth = this.dateOfBirthFormat(legalRequirements.dateOfBirth);
                personalInfo.identifications = this.getMemberIdentifications(legalRequirements.governmentId);
            }
            if(memberTypeId === MemberTypeEnum.DISTRIBUTOR){
                personalInfo.dateOfBirth = this.getDateFormatForEnrollment(personalInformation.dateOfBirth);
                personalInfo.identifications = this.getMemberIdentifications(personalInformation.governmentId,
                    govtIdentificationTypes, personalInfoConfig, countryId, bonusInformation, personalInformation, memberInfo, countryCode);
            }
            personalInfo.externalEmail = personalInformation.externalEmail;
            personalInfo.externalFboId = personalInformation.externalFboId;
            personalInfo.phone = personalInformation.phoneNumber;
            personalInfo.memberBonusInformationModel = this.getBonusInformation(bonusInformation, countryCode);
            personalInfo.businessInformationModel = this.getBusinessInformation(businessInformation,personalInformation.address);
            personalInfo.salutationId = +personalInformation.title;
            return personalInfo;
        }
    }

    getBusinessInformation(businessInfo: BusinessInfo, address: Address): BusinessInfo {
        if (businessInfo && Object.keys(businessInfo).length > 1) {
            businessInfo.businessEntityIdType = BusinessInfoType.C;
            if (businessInfo && address) {
                businessInfo.stateCodeId = address.stateId;
                businessInfo.countryCodeId = address.countryId;
            }
            return businessInfo
        }
        return null;
    }
/**
 * @description formatting dob to the yyyy-mm-dd
 * @date 2019-01-02
 * @param {LegalRequirements} legalRequirements
 * @returns {LegalRequirements}
 * @memberof PersonalInfoComponent
 */
dateOfBirthFormat(dateOfBirth: any) { // getting moment object
    const characterCheck = /[a-zA-z]/;
    if (typeof dateOfBirth._i === DateConstants.Object) {
        dateOfBirth = dateOfBirth._d;
        dateOfBirth = this.momentConstructor(new Date(dateOfBirth)).format(DateConstants.DOBFormat);
    }
    if (typeof dateOfBirth._i === DateConstants.String) {
        dateOfBirth = dateOfBirth._i;
        const dateParts = dateOfBirth.split('-');
        if (characterCheck.test(dateParts[1])) {
            dateOfBirth = moment((dateOfBirth), 'DD-MMM-YYYY')
                .format(DateConstants.DOBFormat);
        } else {
            dateOfBirth = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                .format(DateConstants.DOBFormat);
        }
    }
    return dateOfBirth;
}


updateMemberPreference(memberCommunicationPreferences: MemberPreference[]) {
    this.contactPreferenceModels = [];
    if (memberCommunicationPreferences && memberCommunicationPreferences.length) {
        if (this.privacyPreference) {
            memberCommunicationPreferences.forEach((element) => {
                if (element.preferenceId === ContactPreferenceType.PrivacyPreference) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.YES + '';
                    this.contactPreferenceModels.push({
                        id: element.preferenceId,
                        selected: true
                    });
                }
                if (element.preferenceId === ContactPreferenceType.Email) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.NO + '';
                    this.contactPreferenceModels.push({
                        id: element.preferenceId,
                        selected: false
                    });
                }
            });
        }
        else {
            memberCommunicationPreferences.forEach((element) => {
                if (element.preferenceId === ContactPreferenceType.PrivacyPreference) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.NO + '';
                    this.contactPreferenceModels.push({
                        id: element.preferenceId,
                        selected: false
                    });
                }
                if (element.preferenceId === ContactPreferenceType.Email) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.YES + '';
                    this.contactPreferenceModels.push({
                        id: element.preferenceId,
                        selected: true
                    });
                }
            });
        }
    }
}

    updatePrivacyPreference(memberCommunicationPreferences: MemberPreference[], memberId: number) {
        if (memberCommunicationPreferences && memberCommunicationPreferences.length && memberId) {
            let preferenceChanged;
            memberCommunicationPreferences
                .forEach((element) => {
                    if (element && element.preferenceId && element.preferenceId === ContactPreferenceType.Email) {
                        let preferenceValue = this.privacyPreference ? MemeberCommunicationPreferenceValue.NO : MemeberCommunicationPreferenceValue.YES;
                        preferenceChanged = element.preferenceValue !== preferenceValue + '' ? true : false;
                    }
                });
            if (preferenceChanged) {
                this.updateMemberPreference(memberCommunicationPreferences);
                if (this.contactPreferenceModels && this.contactPreferenceModels.length) {
                    const userId = localStorage.getItem('appadmin.UserId')
                    let updatedBy;
                    if (userId) {
                        updatedBy = +userId;
                    }
                    this._customerService.updateMemberPreferences(memberId, this.contactPreferenceModels,updatedBy).subscribe();
                }
            }
        }
    }



private getDateFormatForEnrollment(dateOfBirth){
    const characterCheck = /[a-zA-z]/;
    const dateParts = dateOfBirth.split('-');
            if (characterCheck.test(dateParts[1])) {
                dateOfBirth =
                    moment(dateOfBirth, DateConstants.DateFormat).format(DateConstants.DOBFormat);
            } else {
                dateOfBirth =
                    moment(dateOfBirth,
                        dateParts && dateParts[2].length === 4 ? DateConstants.DOBConvertFormat : DateConstants.DOBFormat)
                        .format(DateConstants.DOBFormat);
            }
        return dateOfBirth;
}

    /**
     * @description to get current member type
     * @date 2019-09-12
     * @returns {PersonalInfo}
     * @memberof EnrollService
     */
    getCurrentMemberType(memberTypeId: MemberTypeEnum): string {
        let memberTypeValue;
        if (memberTypeId === MemberTypeEnum.GUEST) {
            memberTypeValue = UserTitleType.GUEST;
        } else if ( memberTypeId === MemberTypeEnum.FPC) {
            memberTypeValue = UserTitleType.PREFERREDCUSTOMER;
        } else if (memberTypeId === MemberTypeEnum.RETAIL) {
            memberTypeValue = UserTitleType.RETAIL;
        }
        return memberTypeValue;
    }

    /**
     * @description to get member tilte
     * @date 2019-09-12
     * @returns {PersonalInfo}
     * @memberof EnrollService
     */
    getMemberTitle(memberTypeId: MemberTypeEnum, isEnrollmentFlow?: boolean): string {
        let memberLevel;
        if (memberTypeId === MemberTypeEnum.GUEST) {
            memberLevel = UserTitleType.GUEST;
        } else if (memberTypeId === MemberTypeEnum.FPC) {
            if (isEnrollmentFlow) {
                memberLevel = UserTitleType.PREFERREDCUSTOMER;
            } else {
                memberLevel = UserTitleType.DISTRIBUTOR;
            }
        } else if (memberTypeId === MemberTypeEnum.RETAIL) {
            memberLevel = UserTitleType.RETAIL;
        } else if (memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
            memberLevel = UserTitleType.DISTRIBUTOR;
        }
        return memberLevel;
    }

    /**
     * @description get member identifications
     * @date 2018-08-24
     * @param {PersonalInformation} personalInformation
     * @returns {MemberIdentification[]}
     * @memberof EnrollService
     */
    getMemberIdentifications(governmentId: string, govtIdentificationTypes?: IdentificationType[], personalInfoConfig?: PersonalInfoConfig,
        countryId?: number, bonusInformation?: BonusInfo, personalInformation?: PersonalInformation, memberInfo?: Member,countryCode?:string): MemberIdentification[] {
        let vatId;
        const checkoutConfig = countryCode ? this._checkoutConfigService.getSettings(countryCode, memberInfo) : null;
        if (checkoutConfig && checkoutConfig.vatInPersonalInfo) {
          vatId = personalInformation && personalInformation.vatId ? personalInformation.vatId.replace(/\s/g, '') : null;
        } else {
          vatId = bonusInformation && bonusInformation.vatId ? bonusInformation.vatId.replace(/\s/g, '') : null;
        }
        const govtIdentificationType = personalInfoConfig && personalInfoConfig.identificationType ? personalInfoConfig.identificationType
            : IdentificationTypeConstant.USA;
        const govtIdentification = govtIdentificationTypes ? govtIdentificationTypes.find(x => x.countryID == countryId
            && x.identificationType === govtIdentificationType) : null;
        const identifications: MemberIdentification[] = [
            {
                value: governmentId ? governmentId : vatId,
                identificationId: govtIdentification ? govtIdentification.identificationTypeID : 1,
                identificationType: govtIdentificationType || IdentificationTypeConstant.USA
            }
        ];
        return identifications;
    }

    /**
     * @description
     * @date 2018-09-18
     * @returns {DocumentLibrary[]}
     * @memberof EnrollService
     */
    getAcceptedDocuments(agreementDocuments: DocumentLibrary[], countryId: number, memberTypeId: MemberTypeEnum): DocumentLibrary[] {
        const documents = [];
            if (agreementDocuments) {
                agreementDocuments.forEach((x) => {
                    x.currentDate = this._datePipe.transform(new Date(), 'yyyy-MM-dd hh:mm:ss');
                    documents.push(this.prepareDocumentInformation(x, countryId, memberTypeId));
                });
            }
        return documents;
    }

    /**
     * @description
     * @date 2018-09-18
     * @param {DocumentLibrary} document
     * @returns {DocumentLibrary}
     * @memberof EnrollService
     */
    prepareDocumentInformation(document: DocumentLibrary, countryId: number, memberTypeId: MemberTypeEnum): DocumentLibrary {
        const documentInfo = {
            documentLibraryId: document.documentLibraryId,
            documentLibraryVersionId: document.documentLibraryVersionId,
            currentDate: document.currentDate,
            customerType: document.customerType,
            documentCategoryName: document.documentCategoryName,
            documentCategoryId: document.documentCategoryId,
            version: document.version,
            languageCulture: document.languageCulture,
            countryCode: document.countryCode,
            title: document.title,
            displayName: document.displayName,
            url: document.documentUrl,
            isAcknowledged: true,
            countryId: countryId,
            customerTypeId: this.getCustomerLevel(memberTypeId)
        };
        return documentInfo;
    }

    /**
     * @description This methos used for getting meber level during upgrade flow
     * @date 2018-09-18
     * @param {DocumentLibrary} document
     * @returns {DocumentLibrary}
     * @memberof EnrollService
     */
    getCustomerLevel(registerMemberType): number {
        if (registerMemberType === MemberTypeEnum.RETAIL) {
            return MemberTypeEnum.RETAIL;
        } else if (registerMemberType === MemberTypeEnum.GUEST) {
            return MemberTypeEnum.GUEST;
        } else {
            return MemberLevel.ASSISTANTSUPERVISOR;
        }
    }

    /**
     * @description To get Member contacts
     * @param {PersonalInformation} personalInformation
     * @returns {MemberContact[]}
     * @memberof EnrollService
     */
    getMemberContacts(personalInformation: PersonalInformation): MemberContact[] {
        return [{
            contactTypeID: ContactTypeValue.EMAIL,
            value: personalInformation.email
        }, {
            contactTypeID: personalInformation.phoneType,
            value: personalInformation.phoneNumber ? personalInformation.phoneNumber.replace(/[^a-zA-Z0-9]/g, '') : ''
        }
    ];
    }

    setPrivacyRequested(isPrivacyRequired: boolean) {
        this.privacyPreference = isPrivacyRequired;
    }


    /**
     * @description get member preferences
     * @date 2019-09-10
     * @param {Language} language
     * @returns {MemberPreference[]}
     * @memberof EnrollService
     */
    getMemberPreferences(language: Language, sponsorInformation: SponsorInformation, memberTypeId: MemberTypeEnum, storeInfo: StoreConfig): MemberPreference[] {
        let memberPreferences: MemberPreference[] = [{
            preferenceType: MemberPreferenceType.PREFERRED_LANGUAGE,
            preferenceValue: language ? String(language.languageId) : ''
        }, {
            preferenceType: MemberPreferenceType.PREFERRED_COMMUNICATION_LANGUAGE,
            preferenceValue: language ? String(language.languageId) : ''
        }, {
            preferenceType: MemberPreferenceType.SEND_ME_ANNOUNCEMENTS_TO_MY_MAIL,
            preferenceValue: MemeberCommunicationPreferenceValue.YES + ''
        }];
        const memberCommunicationPreferences = this.getMemberCommunicationPreferences(sponsorInformation, memberTypeId,storeInfo);
        if (memberCommunicationPreferences && memberCommunicationPreferences.length > 0) {
            memberPreferences = memberPreferences.concat(memberCommunicationPreferences);
        }
        const notifyMemberPreferences: MemberPreference = {
            preferenceType: MemberPreferenceType.NOTIFY_ABOUT_PROMOTIONS_AND_UPDATES,
            preferenceValue: (sponsorInformation && sponsorInformation.notifyMeAboutUpdates ?
                MemeberCommunicationPreferenceValue.YES : MemeberCommunicationPreferenceValue.NO) + ''
        };
        memberPreferences.push(notifyMemberPreferences);
        return memberPreferences;
    }

    /**
    * @description get member preferences
    * @date 2019-09-10
    * @param {Language} language
    * @returns {MemberPreference[]}
    * @memberof EnrollService
    */


   getMemberCommunicationPreferences(sponsorInformation: SponsorInformation, memberTypeId: MemberTypeEnum,  storeInfo?: StoreConfig): MemberPreference[] {
    let memberCommunicationPreferences: MemberPreference[];
        if (memberTypeId === MemberTypeEnum.GUEST) {
            let guestpreferenceValue: any = MemeberCommunicationPreferenceValue.NO + '';
            let preferenceConfig = storeInfo && storeInfo.storePreferenceModels;
            let guestpreferenceConfig : any = preferenceConfig && preferenceConfig.find(config => config.memberTypeId === MemberTypeEnum.GUEST);
            if(guestpreferenceConfig && guestpreferenceConfig.value){
                if (guestpreferenceConfig.value === Constants.YES){
                    guestpreferenceValue = MemeberCommunicationPreferenceValue.YES + '';
                }
            }
            memberCommunicationPreferences = [{
                preferenceType: MemberPreferenceType.TO_BE_CONTACTED_BY_SPONSOR_BY_EMAIL,
                preferenceValue: guestpreferenceValue
            }, {
                preferenceType: MemberPreferenceType.TO_BE_CONTACTED_BY_SPONSOR_BY_PHONE,
                preferenceValue: guestpreferenceValue
            }, {
                preferenceType: MemberPreferenceType.PRIVACY_PREFERENCE,
                preferenceValue: guestpreferenceValue
            }];
        }else if (sponsorInformation && sponsorInformation.memberCommunicationPreferences) {
            memberCommunicationPreferences = [{
                preferenceType: MemberPreferenceType.TO_BE_CONTACTED_BY_SPONSOR_BY_EMAIL,
                preferenceValue: (sponsorInformation.memberCommunicationPreferences.email
                    ? MemeberCommunicationPreferenceValue.YES : MemeberCommunicationPreferenceValue.NO) + ''
            }, {
                preferenceType: MemberPreferenceType.TO_BE_CONTACTED_BY_SPONSOR_BY_PHONE,
                preferenceValue: (sponsorInformation.memberCommunicationPreferences.phone
                    ? MemeberCommunicationPreferenceValue.YES : MemeberCommunicationPreferenceValue.NO) + ''
            }, {
                preferenceType: MemberPreferenceType.PRIVACY_PREFERENCE,
                preferenceValue: (sponsorInformation.memberCommunicationPreferences.email
                    ? MemeberCommunicationPreferenceValue.YES : MemeberCommunicationPreferenceValue.NO) + ''
            }];

        }if (storeInfo && storeInfo.enablePrivacyPreference && (memberTypeId === MemberTypeEnum.GUEST || memberTypeId === MemberTypeEnum.RETAIL)){
            memberCommunicationPreferences = this.getMemberCommunicationPreference(memberCommunicationPreferences, storeInfo);
        }
        return memberCommunicationPreferences;
    }

    getMemberCommunicationPreference(memberCommunicationPreferences: MemberPreference[], storeInfo: StoreConfig) {
        if (this.privacyPreference && memberCommunicationPreferences && memberCommunicationPreferences.length) {
            memberCommunicationPreferences.forEach((element) => {
                if (element.preferenceType === MemberPreferenceType.PRIVACY_PREFERENCE) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.YES + '';
                }
                if (element.preferenceType === MemberPreferenceType.TO_BE_CONTACTED_BY_SPONSOR_BY_EMAIL) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.NO + '';
                }
            });
        }
        else {
            memberCommunicationPreferences.forEach((element) => {
                if (element.preferenceType === MemberPreferenceType.PRIVACY_PREFERENCE) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.NO + '';
                }
                if (element.preferenceType === MemberPreferenceType.TO_BE_CONTACTED_BY_SPONSOR_BY_EMAIL) {
                    element.preferenceValue = MemeberCommunicationPreferenceValue.YES + '';
                }
            });
        }

        return memberCommunicationPreferences;
    }

/**
 * This method used for updating member skipped count
 * updateMemberSkipCount
 * @param {number} memberId
 * @param {number} memberSkippedCount
 * @returns
 * @memberof EnrollService
 */
  updateMemberSkipCount(memberId: number, memberSkippedCount: number) {
    const url = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId + '/metadata';
    const memberMetaSkippedCount: MemberMetaDataRequest[] = [];
    const memberMetaData: MemberMetaDataRequest = {
      customKey: MemberMetaDataEnum.UPGRADESKIPPEDCOUNT,
      customValue: memberSkippedCount.toString(),
    };
    memberMetaSkippedCount.push(memberMetaData);
    return this._http
      .put(url, JSON.stringify(memberMetaSkippedCount))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /*
  Reset Password for the User
  */
 sendPasswordResetEmail(email: string, countryCode: string, languageCulture: string, userName?: number) {
    const body: any = {
        authorizedCountry: countryCode,
        languageCode: languageCulture
      };
      let putURL = ApiUrlConstants.enrollmentApigwUrl + 'users/email-for-reset-password/'
      if(email){
        putURL = putURL + encodeURIComponent(email);
      }else {
        putURL = putURL + userName;
      }
   
    return this._http
        .put(putURL, JSON.stringify(body))
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
  }

  updateMemberGovernmentIdentifications(memberId: number, governmentIdentications: any,deleteHomeCountryVat:boolean) {
    const requestModel = JSON.stringify(governmentIdentications);
    const putURL = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId + '/identifications?deleteHomeCountryVat=' + deleteHomeCountryVat;
    return this._http
      .put(putURL, requestModel)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  prepareShippingTax(orderTaxResponse : any ) : number{
    let shippingTax = 0 ;
    if (orderTaxResponse && orderTaxResponse.taxMetaData && orderTaxResponse.taxMetaData.providerName === TaxProvider.VERTEX_CLOUD
         && orderTaxResponse.cart &&
        orderTaxResponse.cart.orderLineItems ) {
        orderTaxResponse
            .cart.orderLineItems.forEach(orderLineItem => {
                const taxType = orderLineItem.itemNumber || orderLineItem.description;
                if (taxType === TaxType.SHP || taxType === TaxType.HND) {
                    shippingTax = shippingTax + orderLineItem.salesTax;
                }
            })
    }
    return shippingTax;
}


    updateBondedWarehouseProject(memberId: number, bondedwarehouseproject: any) {
        const requestModel = JSON.stringify(bondedwarehouseproject);
        const putURL = ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId + '/metadata';
        return this._http
            .put(putURL, requestModel)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    getBonusInformation(bonusInformation, countryCode){
        bonusInformation = bonusInformation ? bonusInformation : null;
        if(countryCode && (countryCode.toLowerCase() == IsoCodeThree.NZL.toLowerCase()) && bonusInformation && bonusInformation.bankNumber && bonusInformation.branchNumber){
            bonusInformation.sortCode = bonusInformation.bankNumber + bonusInformation.branchNumber;
        }
        return bonusInformation;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/enrollment.service.ts